import styled from "styled-components";

export const Container = styled.div``;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 85%;
  gap: 16px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const TooltipWrap = styled.div`
  position: relative;
`;

export const ToolTipIcon = styled.div`
  margin-left: 10px;
  width: 20px;
  height: 20px;
  background: #97f8fb;
  border-radius: 50%;
  font-weight: 500;
  color: #0b29fb;
  text-align: center;
  font-family: "Mangueira Bold", sans-serif;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TooltipIconMobile = styled(ToolTipIcon)`
  position: absolute;
  top: -6px;
  right: 2px;
`;
